<div (mouseleave)="componentsService.highlightComponent(null)">
  <!-- Hidden instructions for screen readers -->
  <div *ngIf="isUserComponents" id="sortable-instructions" class="sr-only">
    Use Space to select an item, then use Up and Down arrow keys to move it. Press Space again to drop the item in its new position, or press Escape to cancel.
  </div>
  <div (rvSortable)="sortItem($event)" appendTo=".attribute-editor" class="sortable-list" tabindex="-1">
    @for (comp of components; track comp; let key = $index) {
      <div class="attribute-row attribute-row-hover rv-sortable-item" [ngClass]="{ 'disabled': requiresUpgrade(comp), 'keyboard-selected': selectedComponentIndex === key }" tabindex="-1">
        @if (isUserComponents) {
          <div 
            class="rv-sortable-handle tw-rounded-sm" 
            tabindex="0" 
            role="button" 
            [attr.data-sortable-index]="key"
            [attr.aria-label]="'Move ' + getDisplayName(comp) + '. Press space to select, then use arrow keys to reorder.'"
            [attr.aria-describedby]="'sortable-instructions'"
            (keydown)="handleSortableKeydown($event, key, comp)"
            (blur)="revertKeyboardSort()"
          >
            <streamline-icon aria-hidden="true" class="streamline-component-icon mr-0" name="sortableHandle" width="14" height="14"></streamline-icon>
          </div>
        }
        <div class="attribute-desc" (mouseenter)="componentsService.highlightComponent(comp.id)">
          <streamline-icon aria-hidden="true" class="streamline-component-icon mr-0" [class.ml-3]="isUserComponents" name="{{ getComponentIcon(comp) }}" width="24" height="18"></streamline-icon>
          <button 
            type="button" 
            id="component-edit-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}" 
            [hidden]="comp.editing" 
            class="madero-link tw-border-0 tw-min-w-[30px] ml-1" 
            [ngClass]="{'strikethrough' : !getComponentVisibility(comp), 'danger': comp.fileMissing, 'disabled': requiresUpgrade(comp) }" 
            [disabled]="!getComponentVisibility(comp) || requiresUpgrade(comp)" 
            (click)="getComponentVisibility(comp) && editComponent(comp, key);"
          >
            {{ getDisplayName(comp) }}
          </button>
          @if (requiresUpgrade(comp) && isPowerBi(comp)) {
            <upgrade-notice #UpgradeNotice feature="power_bi" class="ml-3 mt-2"></upgrade-notice>
          }
          <div [shown]="comp.editing" class="mr-2 flex-grow">
            <input 
              #ComponentName 
              id="input-component-name-{{ key }}" 
              aria-label="Edit component label" 
              attr.aria-describedby="component-edit-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}" 
              class="w-100 form-control p-2 h-auto" 
              type="text" 
              [ngModel]="getDisplayName(comp)" 
              (blur)="saveItemName(key, $event)" 
              (keyup)="itemNameKeyup(key, $event)"
            >
          </div>
        </div>
        <button 
          id="playlistOptionsButton-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}"
          tabindex="0" 
          class="btn btn-icon" 
          [attr.aria-label]="'Options menu for ' + getDisplayName(comp)" 
          mat-menu 
          [matMenuTriggerFor]="playlistOptions">
          <streamline-icon class="streamline-component-icon mr-0" aria-hidden="true" name="ellipsis" width="16" height="16"></streamline-icon>
        </button>
        <mat-menu 
          #playlistOptions="matMenu" 
          id="playlistOptions-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}"
          xPosition="before"
          role="menu"
          tabindex="-1"
          aria-labelledby="playlistOptionsButton-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}">
          @if (!requiresUpgrade(comp)) {
            <button class="playlist-item-rename" tabindex="-1" mat-menu-item role="menuitem" (click)="renameComponent(key)">
              <streamline-icon aria-hidden="true" class="mr-3 streamline-component-icon" name="pencil" width="16" height="16"></streamline-icon>
              <span>Edit Label</span>
            </button>
            @if (storageManagerService.isCanva(comp.source)) {
              <button class="playlist-item-canva" tabindex="-1" mat-menu-item role="menuitem" (click)="editWithCanva(key)">
                <streamline-icon aria-hidden="true" class="mr-3 streamline-component-icon" name="canva" width="16" height="16"></streamline-icon>
                <span>Edit with Canva</span>
              </button>
            }
          }
          <div *ngIf="!isDataComponent(comp)">
            @if (!requiresUpgrade(comp) || !isUserComponents) {
              <button *ngIf="getComponentVisibility(comp)" class="playlist-item-hide" tabindex="-1" mat-menu-item role="menuitem" (click)="setComponentVisibility(comp, false)">
                <streamline-icon aria-hidden="true" class="mr-3 streamline-component-icon" name="hide" width="16" height="16"></streamline-icon>
                <span>Hide</span>
              </button>
              <button *ngIf="!getComponentVisibility(comp)" class="playlist-item-hide" tabindex="-1" mat-menu-item role="menuitem" (click)="setComponentVisibility(comp, true)">
                <streamline-icon aria-hidden="true" class="mr-3 streamline-component-icon" name="show" width="16" height="16"></streamline-icon>
                <span>Show</span>
              </button>
            }
            @if (isUserComponents) {
              <button class="playlist-item-delete" tabindex="-1" mat-menu-item role="menuitem" (click)="removeComponent(key)">
                <streamline-icon aria-hidden="true" class="mr-3 streamline-component-icon" name="trash" width="16" height="16"></streamline-icon>
                <span>Delete</span>
              </button>
            }
          </div>
        </mat-menu>
      </div>
    }
  </div>
</div>
